import { __decorate, __metadata } from "tslib";
import { dispatchUiFallback } from '@1inch-community/core/lit-utils';
import { html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { buttonLoaderStyle, buttonSizeStyle, buttonStyle, buttonTypeStyle } from './button.style';
let ButtonElement = class ButtonElement extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 'xl';
        this.type = 'primary';
        this.fullSize = false;
        this.disabled = false;
        this.loader = false;
        this.disabledSlotPointerEvent = false;
        this.isIconButton = false;
    }
    static { this.tagName = 'inch-button'; }
    static { this.styles = [buttonStyle, buttonSizeStyle, buttonTypeStyle, buttonLoaderStyle]; }
    render() {
        const classes = {
            [this.size]: true,
            [this.type]: true,
            'only-icon': this.isIconButton,
            'full-size': this.fullSize,
            loader: this.loader,
            'active-box-shadow-inset': this.type.includes('secondary') && !this.type.includes('gray'),
        };
        return html `
      <button
        class="${classMap(classes)}"
        @click="${(event) => dispatchUiFallback(this, event)}"
        ?disabled="${this.disabled}"
      >
        <slot
          style="${this.disabledSlotPointerEvent ? 'pointer-events: none;' : ''}"
          @slotchange="${this.handleSlotChange}"
        ></slot>
      </button>
    `;
    }
    handleSlotChange(event) {
        const slot = event.target;
        if (!slot)
            return;
        const nodes = slot.assignedNodes({ flatten: true }).filter((node) => node.nodeName !== '#text');
        this.isIconButton = nodes.length === 1 && nodes[0].nodeName.toLowerCase() === 'inch-icon';
        this.requestUpdate();
    }
};
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], ButtonElement.prototype, "size", void 0);
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], ButtonElement.prototype, "type", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], ButtonElement.prototype, "fullSize", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], ButtonElement.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], ButtonElement.prototype, "loader", void 0);
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Object)
], ButtonElement.prototype, "disabledSlotPointerEvent", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], ButtonElement.prototype, "isIconButton", void 0);
ButtonElement = __decorate([
    customElement(ButtonElement.tagName)
], ButtonElement);
export { ButtonElement };
//# sourceMappingURL=button.element.js.map